import { Competency, LearnerOutcome } from "@/lib/models";
import Image from "next/image";
import { useEntities } from "@/contexts/entities/EntitiesContext";
import { OverviewListCompetencyButton } from "./OverviewListCompetencyButton";

type OverviewListProps = {
  handleEntityClick: (entity: Competency | LearnerOutcome) => void;
  searchResultIds: string[];
  selectedEntity: Competency | LearnerOutcome | null;
};

export const OverviewList = ({
  handleEntityClick,
  searchResultIds,
  selectedEntity,
}: OverviewListProps) => {
  const { learnerOutcomes, getCompetenciesForLearnerOutcome } = useEntities();
  return (
    <section className="col-span-full mb-8 flex flex-col gap-y-4 small:mb-12 medium:mb-[60px] large:col-span-8 large:col-start-3">
      {learnerOutcomes.map((learnerOutcome) => {
        return (
          <div
            key={learnerOutcome.id}
            className="mx-4 rounded-3xl border border-stone-200 bg-white"
          >
            <button
              aria-label={learnerOutcome.name}
              className="m-4 flex items-center small:ml-6 small:mt-8 medium:ml-8"
              onClick={() => handleEntityClick(learnerOutcome)}
            >
              {learnerOutcome.learnerOutcomeCard.sourceUrl && (
                <Image
                  src={learnerOutcome.learnerOutcomeCard.sourceUrl}
                  alt=""
                  width={68}
                  height={78}
                  className="h-[78px] w-[68px] shrink-0 grow-0"
                />
              )}
              <div className="ml-4 text-left">
                <div className="font-roobert text-[10px] font-medium uppercase text-black">
                  Learner Outcome
                </div>
                <div className="font-roobert text-2xl font-medium leading-none text-black">
                  {learnerOutcome.name}
                </div>
              </div>
            </button>
            <div className="m-4 flex flex-col flex-wrap gap-2 small:my-8 small:flex-row medium:mx-6 medium:gap-y-4">
              {getCompetenciesForLearnerOutcome(learnerOutcome.id).map(
                (competency) => (
                  <OverviewListCompetencyButton
                    key={competency.id}
                    searchResultIds={searchResultIds}
                    competency={competency}
                    handleEntityClick={handleEntityClick}
                    learnerOutcomeId={learnerOutcome.id}
                    selectedEntity={selectedEntity}
                  />
                ),
              )}
            </div>
          </div>
        );
      })}
    </section>
  );
};
